<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
      <a href="/">
        <base-img
          :src="require('@/assets/logo.png')"
          href="/"
          contain
          max-width="150"
          width="100%"
      /></a>

      <v-spacer />

      <div>
        <v-tabs class="hidden-sm-and-down" optional>
          <v-tab
            :key="1"
            href="/"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Home
          </v-tab>

          <v-tab
            :key="1"
            href="/about-us"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            About
          </v-tab>

          <v-tab
            :key="1"
            href="/accounting-services"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Accounting Services
          </v-tab>

          <v-tab
            :key="1"
            href="/solutions"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Solutions
          </v-tab>

          <!-- <v-tab
            :key="1"
            href="/netsuite-financial-consulting"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Netsuite Consulting
          </v-tab> -->

          <v-tab
            :key="1"
            href="/pricing"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Pricing
          </v-tab>

          <v-tab
            :key="1"
            href="/promotions"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Promotion
          </v-tab>

          <!-- <v-tab
            :key="1"
            href="/partners"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Partners
          </v-tab> -->

          <!-- <v-tab
            :key="1"
            href="/career"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Career
          </v-tab> -->

          <v-tab
            :key="1"
            href="/contact-us"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Contact
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer")
  },

  data: () => ({
    drawer: null,
    items: [
      {
        name: "Home",
        to: "/"
      },
      {
        name: "About",
        to: "/about-us"
      },
      {
        name: "Accounting Services",
        to: "/accounting-services"
      },
      {
        name: "Netsuite Consulting",
        to: "/netsuite-financial-consulting"
      },
      {
        name: "Pricing",
        to: "/pricing"
      },
      {
        name: "Promotion",
        to: "/promotions"
      },
      {
        name: "Partner",
        to: "/partners"
      },
      {
        name: "Career",
        to: "/career"
      },
      {
        name: "Contact",
        to: "/contact-us"
      }
    ]
  })
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 96px
    margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
<style></style>
